module.exports = __webpack_public_path__ + "static/media/ins-aktywacja.b7bdd247.jpg";